import { Button, Group, Modal, Text } from '@mantine/core';
import { plural } from '../../model/derive';

interface StartMatchingModalProps {
  requestName: string;
  goalCount: number;
  starting: boolean;
  onStart: () => void;
  onClose: () => void;
}

export function StartMatchingModal({
  requestName,
  goalCount,
  starting,
  onStart,
  onClose,
}: StartMatchingModalProps) {
  return (
    <Modal opened onClose={onClose} title="Start matching?" size={520} centered>
      <Text lh={1.5}>
        {requestName} will run with {plural(goalCount, 'matching goal')}.
        Matching can take a while. You can leave the page and come back.
      </Text>
      <Text c="dimmed" mt={6} lh={1.5}>
        After it starts, you can't change your data.
      </Text>
      <Group justify="flex-end" mt="xl">
        <Button variant="default" onClick={onClose} disabled={starting}>
          Go back
        </Button>
        <Button onClick={onStart} loading={starting}>
          Start matching
        </Button>
      </Group>
    </Modal>
  );
}
